/**
 * Side-effect wrapper for chartjs-chart-funnel registration.
 *
 * chartjs-chart-funnel has `"sideEffects": false` in its package.json,
 * causing Vite/Rollup to tree-shake the FunnelController import even though
 * it's used in ChartJS.register(). Importing this file as a side-effect
 * (`import './utils/registerFunnel'`) ensures the registration survives
 * tree-shaking because the import source is our own code, not the external
 * package.
 */
import { FunnelController, TrapezoidElement } from 'chartjs-chart-funnel';
import { Chart as ChartJS } from 'chart.js';

ChartJS.register(FunnelController, TrapezoidElement);

export { FunnelController, TrapezoidElement };
